// components/tabs/RemindersTab.jsx
import { useState } from 'react';
import { EmptyState, Icons } from '../UI';
import { uid, today } from '../../utils/constants';

export default function RemindersTab({ contract, updateC, toggleReminder }) {
  const [newTitle, setNewTitle] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const reminders = contract.reminders || [];
  const pending = reminders.filter(r => !r.done);
  const done = reminders.filter(r => r.done);

  function addReminder() {
    if (!newTitle.trim()) return;
    const updated = [...reminders, {
      id: uid(), done: false, urgent: false,
      title: newTitle.trim(), description: '', due: '', type: 'manual',
    }];
    updateC({ reminders: updated });
    setNewTitle(''); setShowAdd(false);
  }

  function removeReminder(id) {
    updateC({ reminders: reminders.filter(r => r.id !== id) });
  }

  function ReminderRow({ r }) {
    return (
      <div className={`reminder-row ${r.done ? 'done' : r.urgent ? 'urgent' : ''}`}>
        <input type="checkbox" checked={!!r.done} onChange={() => toggleReminder(r.id)}
          style={{ marginTop: 3, flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 13, textDecoration: r.done ? 'line-through' : 'none', color: r.urgent && !r.done ? 'var(--orange-600)' : 'inherit' }}>
            {r.urgent && !r.done && <span style={{ marginRight: 6 }}>⚠</span>}
            {r.title}
          </div>
          {r.description && <div style={{ fontSize: 12, color: 'var(--slate-500)', marginTop: 2 }}>{r.description}</div>}
          {r.due && <div style={{ fontSize: 11, color: 'var(--slate-400)', marginTop: 3 }}>Due: {r.due}</div>}
        </div>
        <button className="btn btn-xs btn-ghost" style={{ color: 'var(--red-400)' }} onClick={() => removeReminder(r.id)}>
          <Icons.trash />
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="card">
        <div className="card-title-row">
          <h3 className="card-title" style={{ marginBottom: 0 }}>
            Action Items & Reminders
            {pending.length > 0 && (
              <span className="badge badge-orange" style={{ marginLeft: 8 }}>{pending.length} pending</span>
            )}
          </h3>
          <button className="btn btn-ghost btn-sm" onClick={() => setShowAdd(s => !s)}>
            <Icons.plus /> Add Item
          </button>
        </div>

        {showAdd && (
          <div style={{ display: 'flex', gap: 10, marginBottom: 16, padding: 12, background: 'var(--slate-50)', borderRadius: 'var(--r-md)' }}>
            <input
              value={newTitle} onChange={e => setNewTitle(e.target.value)}
              placeholder="Reminder title…"
              onKeyDown={e => e.key === 'Enter' && addReminder()}
              style={{ flex: 1, padding: '7px 10px', border: '1.5px solid var(--slate-200)', borderRadius: 'var(--r-md)', fontSize: 13, fontFamily: 'var(--font-sans)' }}
              autoFocus
            />
            <button className="btn btn-primary btn-sm" onClick={addReminder}>Add</button>
            <button className="btn btn-ghost btn-sm" onClick={() => setShowAdd(false)}>Cancel</button>
          </div>
        )}

        {reminders.length === 0 ? (
          <EmptyState icon="◎" title="No reminders yet"
            subtitle="Reminders are auto-generated when you advance stages. You can also add them manually."
            action={<button className="btn btn-ghost" onClick={() => setShowAdd(true)}><Icons.plus /> Add Reminder</button>} />
        ) : (
          <>
            {pending.length > 0 && (
              <>
                <div className="section-label">Pending ({pending.length})</div>
                {pending.map(r => <ReminderRow key={r.id} r={r} />)}
              </>
            )}
            {done.length > 0 && (
              <>
                <div className="section-label" style={{ marginTop: 16 }}>Completed ({done.length})</div>
                {done.map(r => <ReminderRow key={r.id} r={r} />)}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
